import Actions from ".";
import { get, post, deleteCall } from "../../../utils/api";
import { API_ERROR_MESSAGE } from "../../../constants";

const getUsers = () => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`user/list-users`);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: data.response.users || [],
          nextPageToken: data.response.nextPageToken,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
          list: [],
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        list: [],
      })
    );
  }
};

const loadMoreUsers = () => async (dispatch, getState) => {
  const {
    appUsers: { nextPageToken, list },
  } = getState();
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`user/list-users?nextPageToken=${nextPageToken}`);
    if (data.statusCode === 200 && data.response) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: [...list, ...data.response.users],
          nextPageToken: (data.response || {}).nextPageToken,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          nextPageToken: null,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        nextPageToken: null,
      })
    );
  }
};

const searchUsers = () => async (dispatch, getState) => {
  const {
    appUsers: { searchText },
  } = getState();
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`user/list-users?searchText=${searchText}`);
    if (data.statusCode === 200 && data.response) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: data.response.users || [],
          nextPageToken: data.response.nextPageToken,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          nextPageToken: null,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        nextPageToken: null,
      })
    );
  }
};

const getUserDetails = (id) => async (dispatch) => {
  dispatch(Actions.updateProperty("loadingData", true));
  try {
    const data = await get(`user/get-user/${id}`);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loadingData: false,
          error: "",
          data: data.response || {},
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loadingData: false,
          error: data.message || API_ERROR_MESSAGE,
          data: {},
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingData: false,
        error: e.message || API_ERROR_MESSAGE,
        data: {},
      })
    );
  }
};

const getCart = (id) => async (dispatch) => {
  dispatch(Actions.updateProperty("loadingCart", true));
  try {
    const data = await get(`cart/admin/${id}`);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loadingCart: false,
          error: "",
          cart: data.response || {},
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loadingCart: false,
          error: data.message || API_ERROR_MESSAGE,
          cart: {},
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingCart: false,
        error: e.message || API_ERROR_MESSAGE,
        cart: {},
      })
    );
  }
};

const addProduct = (body) => async (dispatch, getState) => {
  const {
    data: { id },
  } = getState().appUsers;
  dispatch(Actions.updateProperty("loadingCart", true));
  try {
    const data = await post(`cart/admin/${id}`, body);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loadingCart: false,
          error: "",
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loadingCart: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
    dispatch(getCart(id));
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingData: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const removeProduct = (body) => async (dispatch, getState) => {
  const {
    data: { id },
  } = getState().appUsers;
  dispatch(Actions.updateProperty("loadingCart", true));
  try {
    const data = await deleteCall(`cart/admin/${id}`, body);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
    dispatch(getCart(id));
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingData: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const editUser = (body) => async (dispatch) => {
  dispatch(Actions.updateProperty("loadingCart", true));
  try {
    const data = await post(`user/`, body);
    if (data.statusCode === 200) {
      dispatch(
        Actions.updateProperties({
          loadingCart: false,
          error: "",
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loadingCart: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
    dispatch(getUsers());
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingData: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const getVersions = () => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`admin/version/list`);
    if (data.status) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: data.response || [],
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
          list: [],
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        list: [],
      })
    );
  }
};

const fetchPincodes = (body) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`admin/location/pincodes?district=` + body);
    if (data.status) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          list: data.response || [],
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
          list: [],
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        list: [],
      })
    );
  }
};

const fetchWareHouse = (warehouseId) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await get(`admin/warehouse/${warehouseId}`);
    if (data.status) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          success: true,
          wareHouseList: data.response || [],
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
          list: [],
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
        list: [],
      })
    );
  }
};

const addPinCode = (body, warehouseId) => async (dispatch) => {
  dispatch(Actions.updateProperty("loadingCart", true));
  try {
    const data = await post(`admin/warehouse/${warehouseId}/zone`, body);
    if (data.status) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          showModal: false,
        })
      );
      dispatch(fetchWareHouse(warehouseId));
    } else {
      dispatch(
        Actions.updateProperties({
          loadingCart: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
    dispatch(getVersions());
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingData: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const addVersion = (body) => async (dispatch) => {
  dispatch(Actions.updateProperty("loadingCart", true));
  try {
    const data = await post(`admin/version/add`, body);
    if (data.status) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
          showModal: false,
        })
      );
    } else {
      dispatch(
        Actions.updateProperties({
          loadingCart: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
    dispatch(getVersions());
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loadingData: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const deleteVersion = (id) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await deleteCall(`admin/version/${id}`);
    if (data.status) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
        })
      );
      dispatch(getVersions());
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

const deletePinCode = (body, warehouseId) => async (dispatch) => {
  dispatch(Actions.updateProperty("loading", true));
  try {
    const data = await deleteCall(`/admin/warehouse/${warehouseId}/zone`, body);
    if (data.status) {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: "",
        })
      );
      dispatch(fetchWareHouse(warehouseId));
    } else {
      dispatch(
        Actions.updateProperties({
          loading: false,
          error: data.message || API_ERROR_MESSAGE,
        })
      );
    }
  } catch (e) {
    dispatch(
      Actions.updateProperties({
        loading: false,
        error: e.message || API_ERROR_MESSAGE,
      })
    );
  }
};

export default {
  getUsers,
  loadMoreUsers,
  getUserDetails,
  getCart,
  addProduct,
  removeProduct,
  editUser,
  getVersions,
  addVersion,
  deleteVersion,
  searchUsers,
  fetchPincodes,
  fetchWareHouse,
  addPinCode,
  deletePinCode,
};
